type ComingSoonPageProps = {
  /** Page heading */
  title: string;
  /** What the page will show */
  description: string;
  /** Data it will read */
  source: string;
};

/** Placeholder for a section planned in a follow-up ticket. */
export const ComingSoonPage = ({
  title,
  description,
  source,
}: ComingSoonPageProps) => (
  <div className="card mx-auto max-w-2xl p-8 text-center">
    <h1 className="text-xl font-semibold">{title}</h1>
    <p className="mt-2 text-sm text-slate-600">{description}</p>
    <p className="mt-4 text-xs text-slate-500">{source}</p>
  </div>
);
